import { render } from "./quantitativeIntelligenceMonitoring.vue?vue&type=template&id=0efb454a&scoped=true"
import script from "./quantitativeIntelligenceMonitoring.vue?vue&type=script&lang=js"
export * from "./quantitativeIntelligenceMonitoring.vue?vue&type=script&lang=js"

import "./quantitativeIntelligenceMonitoring.vue?vue&type=style&index=0&id=0efb454a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0efb454a"

export default script